import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const TileContainer = styled.div`
  background: var(--t-brand-bg-color, #ffffff);
  border: 1px solid var(--t-horizontal-vertical-rule, #c4c4c4);
  padding: 0.3rem 1rem;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: max-content;
  cursor: pointer;
  border-radius: 99px;
  margin-bottom: 10px;
`;

export const TileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TileIcon = styled.div`
  position: relative;
  width: ${toRem(24)};
  height: ${toRem(24)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  margin-right: 4px;
  color: hsl(23, 68.7%, 52.4%);
  svg {
    width: ${toRem(24)};
    height: ${toRem(24)};
    display: block;
  }
`;

export const TileTitle = styled.h4`
  margin: 0;
  font-size: ${toRem(14)};
  font-weight: 500;
  color: var(--t-brand-fg-color, #1c1c1c);
  font-family: var(--t-title-font-family);
`;
